<style src="./BoardDetails.scss" lang="scss"></style>
<template>
  <section class="board-details">
    <section
      class="empty-board"
      v-if="!board">
      Não foi selecionado
    </section>

    <ul class="board">
      <stages-header
        :stages="header.stages" />
      <div
        class="preloader"
        v-show="preloader">
        Aguarde enquanto efetuamos a busca..
      </div>

      <div
        class="preloader"
        v-show="events.list && events.list.length === 0">
        Não encontramos nenhum resultado
      </div>

      <template
        v-for="(event, eventIdx) in events.list">
        <events-content
          :key="eventIdx"
          :event="event"
          :stages="header.stages"
          @task-selected="(task) => { taskSelected({ task, event }) }" />
      </template>
    </ul>

    <div class="paginator">
      <page-navigator
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />
    </div>
    
    <modal
      transition="nice-modal-fade"
      name="stageModal"
      width="1000px"
      height="auto"
      :scrollable="true"
      @closed="whenCloseModal">
      <div slot="top-right">
        <div
          class="close-command"
          @click="$modal.hide()">
          <icon-close class="icon-close" />
        </div>
      </div>
      
      <template v-if="!!modalDetails.stage.id">
        <div class="modal-details">
          <board-header
            :modal-details="modalDetails"/>
          <board-task-commands
            :can-showopen-task="canShowOpenTask"
            :can-show-finish-task="canShowFinishTask"
            @open-task="openTask"
            @finish-task="finishTask" />
          <board-locked-task
            v-if="canShowOpenTask"
            @open-task="openTask" />

          <template v-if="!canShowOpenTask">
            <bid-capture
              class="board-content"
              v-if="modalDetails.stage.name === 'Captação'"
              :event-id="modalDetails.event.id" />

            <insert-items
              class="board-content"
              v-if="modalDetails.stage.name === 'Cadastro de Itens'"
              :event-id="modalDetails.event.id" />
            
            <bid-capture
              class="board-content"
              v-if="modalDetails.stage.name === 'Captação'"
              :event-id="modalDetails.event.id" />

            <analyse
              class="board-content"
              v-if="modalDetails.stage.name === 'Analise'"
              :stage-id="modalDetails.stage.id"
              :event-id="modalDetails.event.id"
              :participate="modalDetails.participate"
              :participate-reason="modalDetails.participateReason" />

            <insert-items
              class="board-content"
              v-if="modalDetails.stage.name === 'Cadastro de Itens'"
              :event-id="modalDetails.event.id" />

            <bid-mirror
              class="board-content"
              v-if="modalDetails.stage.name === 'Leitura do Edital'"
              :event-id="modalDetails.event.id" />
            
            <item-association
              class="board-content"
              v-if="modalDetails.stage.name === 'Associação dos Itens'"
              :event-id="modalDetails.event.id" />

            <in-progress
              class="board-content"
              v-if="modalDetails.stage.name === 'Em Andamento'"
              :stage-id="modalDetails.stage.id"
              :event-id="modalDetails.event.id"
              :waiting="modalDetails.waiting"
              :willStart="modalDetails.willStart"
              :meta="modalDetails.meta"
              :status="modalDetails.filterStatus" />

            <result
              class="board-content"
              v-if="modalDetails.stage.name === 'Resultado'"
              :event-id="modalDetails.event.id" />
          </template>

          <modal-chat
            class="board-chat"
            :stage-id="modalDetails.stage.id"
            :event-id="modalDetails.event.id" />
          
          <board-assigned-user
            @task-participate="taskParticipate"
            v-model="modalDetails.assignedUser"
            :can-show-participate-task="canShowParticipateTask" />
          <board-responsible-user
            v-model="modalDetails.responsibleUser"
            :user-list="modalForm.users"
            @selected="modalSetUser" />
          <board-files
            :event-id="modalDetails.event.id" />
        </div>
      </template>
    </modal>
  </section>
</template>

<script>
  import { IconBidNotice, IconClose } from '@/components/primitives/icons'
  import { ListUsers } from '@/brain/record/user'
  import { Dropdown, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
  import ModalUsers from '../modal-users/ModalUsers'
  import ModalStages from '../modal-stages/ModalStages'
  
  import StagesHeader from '../stages-header/StagesHeader'
  import EventsContent from '../events-content/EventsContent'
  
  import moment from 'moment'
  import { db } from '@/communication/FirebaseConfig'

  import BidCapture from '@/components/event/bid-capture/BidCapture'
  import Analyse from '@/components/event/analyse/Analyse'
  import InsertItems from '@/components/event/insert-items/InsertItems'
  import BidMirror from '@/components/event/bid-mirror/BidMirror'
  import InProgress from '@/components/event/in-progress/InProgress'
  import ItemAssociation from '@/components/event/item-association/ItemAssociation'
  import Result from '@/components/event/result/Result'

  import ModalChat from '@/components/foundation/modal-chat/ModalChat'

  import BoardHeader from './components/board-header/BoardHeader'
  import BoardTaskCommands from './components/board-task-commands/BoardTaskCommands'
  import BoardLockedTask from './components/board-locked-task/BoardLockedTask'
  import BoardAssignedUser from './components/board-assigned-user/BoardAssignedUser'
  import BoardResponsibleUser from './components/board-responsible-user/BoardResponsibleUser'
  import BoardFiles from './components/board-files/BoardFiles'

  import { mapGetters } from 'vuex'

  let firestoreBoard = () => {}

  export default {
    name: 'BoardDetails',
    components: {
      IconBidNotice,
      IconClose,
      Dropdown,
      PageNavigator,
      ModalUsers,
      ModalStages,
      StagesHeader,
      EventsContent,
      BidCapture,
      Analyse,
      InsertItems,
      ModalChat,
      BidMirror,
      InProgress,
      ItemAssociation,
      Result,
      BoardHeader,
      BoardTaskCommands,
      BoardLockedTask,
      BoardAssignedUser,
      BoardResponsibleUser,
      BoardFiles
    },
    extends: {
      ...SourcePaginatorMixin
    },
    props: {
      board: {
        default: null
      }
    },
    data: () => ({
      preloader: false,
      header: {
        boardName: null,
        stages: []
      },
      events: {
        list: null
      },
      modalDetails: {
        stage: {
          id: null,
          name: null
        },
        event: {
          id: null,
          name: null
        },
        completeInfo: false,
        isOpened: false,
        openedBy: {},
        responsibleUser: [],
        nextStage: [],
        chat: [],
        assignedUser: [],
        attachedFiles: [],
        participate: null,
        participateReason: null,
        filterStatus: null,
        waiting: null,
        willStart: null
      },
      modalForm: {
        user: [],
        users: [],
        stage: [],
        stages: []
      }
    }),
    filters: {
      DateTime (dt) {
        return moment(dt).format(`DD/MM/YYYY [às] HH:mm`)
      },
      translateDocType (docType) {
        switch (docType) {
          case 'BID-NOTICE':
            return 'Edital'
        }
      }
    },
    watch: {
      paginator: {
        handler () {
          const query = this.buildQuery()
          this.$store.commit('Board/SET_FILTER', query)
        },
        deep: true
      },
      filters: {
        handler (v) {
          this.loadEventWithTask()
        },
        deep: true
      }
    },
    mounted () {
      this.loadUsers()
      this.loadEventWithTask()
      this.$store.dispatch('Distributors/LOAD_DEFAULT')

      try {
        firestoreBoard = db.collection('board').doc('refresh')
          .onSnapshot((doc) => {
            this.loadEventWithTask()
          })
      } catch (error) {
        console.log('erro no firebase')
      }
    },
    beforeDestroy () {
      firestoreBoard()
    },
    computed: {
      ...mapGetters({
        filters: 'Board/FILTERS'
      }),
      stageContainer () {},
      taskOpenedBy () {
        const openedBy = this.modalDetails.assignedUser.find(item => item.hasOwnProperty('open'))
        if (openedBy) return openedBy
        return false
      },
      canShowFinishTask () {
        if (this.modalDetails.stage.name === 'Captação' && !this.modalDetails.completeInfo) return false
        // if (this.modalDetails.stage.name === 'Analise') return false
        if (this.modalDetails.isOpened) {
          return true
        }

        return false
      },
      canShowOpenTask () {
        // if (this.modalDetails.stage.name === 'Analise') return false
        // if (this.modalDetails.stage.name === 'Captação') return false
        if (!this.modalDetails.isOpened) {
          return true
        }

        return false
      },
      canShowParticipateTask () {
        // if (this.modalDetails.stage.name === 'Analise') return false
        // if (this.modalDetails.stage.name === 'Captação') return false
        if (this.modalDetails.isOpened) {
          return true
        }

        return false
      }
    },
    methods: {
      async loadUsers () {
        const users = await ListUsers()
        this.modalForm.users = users.map(item => ({
          text: item.name,
          value: item._id
        }))
      },
      async loadEventWithTask () {
        if (!this.board) { return }
        this.preloader = true
        this.events.list = null

        try {
          await this.$store.dispatch('Board/LOAD_SHEET')
  
          const rows = this.$store.getters['Board/ROWS']
  
          this.paginator.totalRegister = rows
          this.paginator.totalPage = Math.floor(rows / this.paginator.perPage)
  
          this.header.boardName = this.$store.getters['Board/BOARD_NAME']
          this.header.stages = this.$store.getters['Board/STAGES']
  
          this.events.list = this.$store.getters['Board/EVENTS']
  
          this.modalForm.stages = this.$store.getters['Board/STAGES'].map(stage => ({
            text: stage.name,
            value: stage._id
          }))
        } catch (error) {
          this.$toasted.error('Ocorreu um erro durante a busca')
        } finally {
          this.preloader = false
        }
      },
      async taskSelected ({ event, task }) {
        const payload = {
          stageId: task.task.stage,
          eventId: event.id
        }
        const taskDetail = await this.$store.dispatch('Board/GET_TASK_DETAILS', payload)
        const stageDetail = this.$store.getters['Board/STAGE_BY_ID'](task.task.stage)
        this.modalDetails.stage.id = task.task.stage
        this.modalDetails.stage.name = stageDetail.name
        this.modalDetails.event.id = event.id
        this.modalDetails.event.name = event.name

        this.modalDetails.completeInfo = taskDetail.completeInfo
        this.modalDetails.isOpened = taskDetail.isOpened
        this.modalDetails.nextStage = taskDetail.nextStage
        this.modalDetails.chat = taskDetail.chat
        this.modalDetails.openedBy = taskDetail.assignedUser.find(item => item.hasOwnProperty('open'))
        this.modalDetails.assignedUser = this.mapAssignedUser(taskDetail.assignedUser)
        this.modalDetails.responsibleUser = this.mapResponsibleUser(taskDetail.responsibleUser)
        this.modalDetails.attachedFiles = taskDetail.attachedFiles
        this.modalDetails.participate = taskDetail.participate
        this.modalDetails.participateReason = taskDetail.participateReason
        this.modalDetails.filterStatus = taskDetail.stageFilterStatus && taskDetail.stageFilterStatus.status
        this.modalDetails.meta = taskDetail.stageFilterStatus && taskDetail.stageFilterStatus.meta
        this.modalDetails.waiting = taskDetail.waiting
        this.modalDetails.willStart = taskDetail.willStart
        this.$modal.show('stageModal')
      },
      mapAssignedUser (users) {
        return users
          .filter(list => list.hasOwnProperty('start'))
          .map(({ user }) => ({
            id: user._id,
            text: user.name,
            avatar: user.avatar
          }))
      },
      mapResponsibleUser (users) {
        return users
          .map((user) => ({
            id: user._id,
            text: user.name,
            avatar: user.avatar
          }))
      },
      async openTask () {
        const responsibleUser = this.modalDetails.responsibleUser.map(item => (item.id))
        const nextStage = this.modalDetails.nextStage &&
          this.modalDetails.nextStage.map(item => (item._id))
        const payload = {
          stageId: this.modalDetails.stage.id,
          eventId: this.modalDetails.event.id,
          responsibleUser,
          nextStage
        }
        await this.$store.dispatch('Board/OPEN_TASK', payload)

        this.loadEventWithTask()
      },
      async finishTask (task) {
        const payload = {
          stageId: this.modalDetails.stage.id,
          eventId: this.modalDetails.event.id
        }
        await this.$store.dispatch('Board/FINISH_TASK', payload)
        this.$toasted.success('tarefa concluída')

        this.loadEventWithTask()
      },
      async modalSetUser (user) {
        if (this.modalDetails.responsibleUser.find(item => item.id && item.id.toString() === user.value)) {
          this.$toasted.error('O participante já foi selecionado')
          return false
        }
        this.modalDetails.responsibleUser.push({
          text: user.text,
          id: user.value,
          avatar: user.avatar
        })

        const payload = {
          stageId: this.modalDetails.stage.id,
          eventId: this.modalDetails.event.id,
          responsibleUserId: user.value
        }

        await this.$store.dispatch('Board/ADD_RESPONSIBLE_USER', payload)
      },
      async modalRemoveUser (user) {
        if (!this.modalDetails.responsibleUser.find(item => item.id && item.id.toString() === user.value)) {
          const payload = {
            stageId: this.modalDetails.stage.id,
            eventId: this.modalDetails.event.id,
            responsibleUserId: user.id
          }

          await this.$store.dispatch('Board/REMOVE_RESPONSIBLE_USER', payload)
        } else {
          this.$toasted.error('O participante já foi removido')
          return false
        }
      },
      modalSetStage () {},
      async taskParticipate () {
        const payload = {
          stageId: this.modalDetails.stage.id,
          eventId: this.modalDetails.event.id
        }
        await this.$store.dispatch('Board/TASK_PARTICIPATE', payload)

        this.loadEventWithTask()
      },
      downloadDocument (pathFile) {
        window.open(pathFile, '_target')
      },
      resetPaginator () {
        this.paginator.actualPage = 0
      },
      whenCloseModal () {
        this.loadEventWithTask()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/BoardDetails.vue